<template>
  <div class="f-v f-ast">
    <donut-modal-sections-title :title="modalTitle" />
    <div class="t">{{ modalDescription }}</div>
    <bonus-event-templates-modals-message-form>
      <!-- Title -->
      <div class="t">Event name</div>
      <div class="t gray m-t">This name is only visible to admins.</div>
      <input v-model="title" placeholder="Wedding Gift, New Baby, Promotion" class="m-t">
      <!-- Description -->
      <div class="t m-tx2">Description (Optional)</div>
      <div class="t gray m-t">Add guidelines for when other admins should use this.</div>
      <donut-input-text
        v-model="description"
        placeholder="Standard bonus for full-time employees getting married."
        :autogrow="true"
        :textarea="true"
        :wysiwyg="false"
        :max-length="2500"
        class="m-t"
      />
    </bonus-event-templates-modals-message-form>
    <donut-modal-sections-actions
      :button-text="isNew ? 'Create' : 'Save'"
      :is-save-disabled="isSaveDisabled"
      :loading-on-save="true"
      save-action="bonusEventTemplates/upsertActiveTemplate"
    />
  </div>
</template>

<script setup>
  import { computed } from 'vue';
  import { useStore } from 'vuex';

  const { state, commit } = useStore();
  const isNew = !state.bonusEventTemplates.activeTemplate.id;

  // Modal Copy
  const modalTitle = `${isNew ? 'Create' : 'Edit'} Bonus Event`;
  const modalDescription = 'Set up reusable bonus events for work and life milestones.';

  // Editable Values
  const title = computed({
    get() { return state.bonusEventTemplates.activeTemplate.title; },
    set(value) { commit('bonusEventTemplates/updateActiveTemplate', { key: 'title', value }); },
  });
  const description = computed({
    get() { return state.bonusEventTemplates.activeTemplate.description; },
    set(value) { commit('bonusEventTemplates/updateActiveTemplate', { key: 'description', value }); },
  });

  // Saving
  const isSaveDisabled = computed(() => {
    const { message, points } = state.bonusEventTemplates.activeTemplate;
    return !title.value.trim() || !message.trim() || points <= 0 || parseInt(points) !== points;
  });
</script>
